define('views/content/reports/reseller_sales',['require','backbone','marionette','bootstrap-daterangepicker','datatables','typeahead','bloodhound','text!templates/content/reports/reseller_sales.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('bootstrap-daterangepicker');
    require('datatables');
    require('typeahead');
    require('bloodhound');

    var temp = require("text!templates/content/reports/reseller_sales.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'reseller_sales',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                reportDateRangePicker: '#report-range-picker',
                reportDateRangeTabs: '.report-range-tabs',
                reportDateRangeTab: '.report-range-tabs li',

                salesTable: '.sales-list',

                resellerField: '#reseller'
            };
        },

        events: {
            'click @ui.reportDateRangeTab': 'reportDateRangeTabClicked'
        },

        onRender: function () {
            var _this = this;

            this.ui.reportDateRangePicker.daterangepicker({
                timePicker: false,
                format:'YYYY-MM-DD',
                autoApply: true
            });

            this.ui.reportDateRangePicker.on('hide.daterangepicker', function () {
                _this.getReports();
            });

            var startTime = localStorage.getItem('report_start_time');
            var endTime = localStorage.getItem('report_end_time');
            if (startTime && endTime) {
                this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(new Date(parseInt(startTime)));
                this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(new Date(parseInt(endTime)));
            }

            // Setup typeahed for reseller field
            var resellersTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'resellers/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + encodeURIComponent(_this.ui.resellerField.val()));
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.resellerField.typeahead({
                minLength: 3
            }, {
                name: 'resellers',
                source: resellersTypeahedEngine,
                display: 'company_name'
            });

            // Get selected customer's id
            this.ui.resellerField.bind('typeahead:select', function (ev, suggestion) {
                _this.selectedReseller = suggestion.id;

                _this.getReports();
            });

            // Load directly if reseller id provide in url paramters
            var resellerId = App.utils.getUrlParameter('reseller_id');
            if (resellerId) {
                this.selectedReseller = resellerId;
                this.getReports();
            }
        },

        reportDateRangeTabClicked: function (e) {
            var clickedTab = $(e.currentTarget);
            var currentTab = this.ui.reportDateRangeTabs.find('li.active');

            if (clickedTab != currentTab) {
                currentTab.removeClass('active');
                clickedTab.addClass('active');

                var rangeKey = clickedTab.attr('data-range');

                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);

                if (rangeKey == 'day') {
                    var today = new Date();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(today);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'week') {
                    var weekStart = App.utils.getWeekStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(weekStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'month') {
                    var monthStart = App.utils.getMonthStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);

                } else if (rangeKey == 'year') {
                    var yearStart = App.utils.getYearStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(yearStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'last_30_days') {
                    var monthAgo = new Date(tomorrow.getTime());
                    monthAgo.setDate(monthAgo.getDate() - 30);

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthAgo);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                }

                this.getReports();
            }
        },

        getReports: function () {
            var _this = this;

            // Save date parameters in local storage
            localStorage.setItem('report_start_time', this.ui.reportDateRangePicker.data('daterangepicker').startDate.toDate().getTime());
            localStorage.setItem('report_end_time', this.ui.reportDateRangePicker.data('daterangepicker').endDate.toDate().getTime());

            if (this.selectedReseller) {
                // Proceed only if a reseller is selected
                $.ajax({
                    url: App.Config.apiBase + 'reports/reseller-sales-reports/',
                    method: 'get',
                    data: {
                        start_date: this.ui.reportDateRangePicker.data('daterangepicker').startDate.format('YYYY-MM-DD'),
                        end_date: this.ui.reportDateRangePicker.data('daterangepicker').endDate.format('YYYY-MM-DD'),
                        reseller: this.selectedReseller
                    },
                    success: function (response) {
                        _this.showResellerSaleReports(response.reseller_report);
                    }
                });
            }
        },

        showResellerSaleReports: function (reportData) {
            // Transform report data for datatables format
            var gridData = [];

            var totalRow = {
                count: 0,
                price: 0
            };

            reportData.forEach(function (reportRow) {
                gridData.push([
                    '<a href="/products/' + reportRow.product.id + '">' + reportRow.product.name + '<a/>',
                    reportRow.count,
                    (reportRow.price.toFixed(2) + ' $')]);

                totalRow.count += reportRow.count;
                totalRow.price += reportRow.price;
            });

            // Add total row
            gridData.push([
                App.polyglot.t('total'),
                totalRow.count,
                (totalRow.price.toFixed(2) + ' $')
            ]);

            if (!this.salesDataTable) {
                this.salesDataTable = this.ui.salesTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    columns: [
                        { title: App.polyglot.t('product') },
                        { title: App.polyglot.t('count'), className: 'text-right' },
                        { title: App.polyglot.t('price'), className: 'text-right' }
                    ],
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.salesDataTable.clear();
                this.salesDataTable.rows.add(gridData);
                this.salesDataTable.columns.adjust().draw();
            }
        }

    });
});
